import {CHANGE_INFO_ANIMAL_DETAIL, LOAD_PROTECTORA_DETAIL, MODE_EMAIL} from '../../AnimalList/actions/actionsAnimalList'
import {ERROR_INSERT_ANIMAL, LOAD_ANIMAL_DETAIL} from "../../Animal/actions/actionsAnimal";

const initialState = {
    showAnimalDetail: false,
    index: -1,
    indexRow: -1,
    infoAnimalDetail: {},
    infoProtectoraDetail: {},
    tabInfoDetail: 0,
    modeEmail: false,
    error: false
};

export function reducerAnimal(state = initialState, action) {

    switch (action.type) {
        case LOAD_ANIMAL_DETAIL:
            return Object.assign({}, state, {
                infoAnimalDetail: action.payload.infoAnimalDetail
            });
        case LOAD_PROTECTORA_DETAIL:
            return Object.assign({}, state, {
                infoProtectoraDetail: action.payload.infoProtectoraDetail
            });
        case CHANGE_INFO_ANIMAL_DETAIL:
            return Object.assign({}, state, {
                tabInfoDetail: action.payload.tabInfoDetail
            });
        case MODE_EMAIL:
            return Object.assign({}, state, {
                modeEmail: action.payload.modeEmail
            });
        case ERROR_INSERT_ANIMAL:
            return {...state, errorInsertAnimal: action.payload.errorInsertAnimal};
        default:
            return state
    }
}